import { useLazyQuery } from '@apollo/client';
import { SHARE_LISTINGS_LINK_QUERY } from '../../graphql/search-queries';

export default function useGetShareListingsLink() {
    const [getListingsLink, { data, loading, error }] = useLazyQuery(SHARE_LISTINGS_LINK_QUERY);
    return { getListingsLink, data, loading, error };
}
